import { PaymentStatusType } from "@types";

export interface IPaymentMethod {
  paymentId: number;
  gateway: string;
  online: boolean;
  status: PaymentStatusType;
  text: string;
  price: number;
  isRefund: boolean | null;
  paymentDate: string | null;
}
